import { Box, Icons } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { JobType } from 'components/account/jobs/job_type';
import { AMLCaption } from 'components/account/jobs-v2/dropdowns/AML/AMLCaption';
import { AMLDropdowns } from 'components/account/jobs-v2/dropdowns/AML/AMLDropdowns';
import { AmlV2Dropdowns } from 'components/account/jobs-v2/dropdowns/AML/AmlV2Dropdowns';
import { Dropdown } from 'components/account/jobs-v2/dropdowns/Dropdown';
import { useGlobalState } from 'store/reducers/reducer';
import { getAmlV2Job } from 'store/sagas/sagas';
export const AmlPageSwitch = ({ isAMLOnly, jobAMLResults, jobErrors, jobSid, jobStatus, jobType }) => {
    const { asyncDispatch } = useGlobalState();
    const [amlV2Job, setAmlV2Job] = useState();
    useEffect(() => {
        if (jobType === JobType.idAml) {
            asyncDispatch(getAmlV2Job(jobSid)).then(setAmlV2Job, console.error);
        }
    }, [jobType, jobSid]);
    if (!amlV2Job)
        return (React.createElement(Dropdown, { title: "AML" },
            React.createElement(Box, null,
                React.createElement(AMLCaption, null),
                React.createElement(Icons.Loading, null))));
    return amlV2Job.version === 'v1' ? (React.createElement(AMLDropdowns, { isAMLOnly: isAMLOnly, jobAMLResults: jobAMLResults, jobErrors: jobErrors, jobSid: jobSid, jobStatus: jobStatus })) : (React.createElement(AmlV2Dropdowns, { job: amlV2Job, jobStatus: jobStatus }));
};
